import { Box, Heading, Paragraph } from '@zillow/constellation-10';
import { IconHouseHeartFilled } from '@zillow/constellation-icons';

import { useMultiplexListingFlow } from '../../../../hooks/queries/multiplex';

import WizardTipCardContainer from '../../../../../srcLegacy/shared/components/WizardTipCardContainer';
import { FinancialExpectationsIntroAndFields } from './components/FinancialExpectationsIntroAndFields';

import {
  wizardFlexContainerStyles,
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
} from '../../../../styles/wizard';

import PageWizard from '../../../Wizard/PageWizard';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const FinancialExpectations = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}: WizardBodyTemplateProps) => {
  const { isInMultiplexListingFlow } = useMultiplexListingFlow();

  return (
    <PageWizard
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
      {...rest}
    >
      <div data-testid="FinancialExpectations">
        <Box css={wizardFlexContainerStyles}>
          <Box
            data-testid="FormSectionContainer"
            css={wizardFormSectionContainerStyles.raw({ isInMultiplexListingFlow: Boolean(isInMultiplexListingFlow) })}
          >
            {!isInMultiplexListingFlow && (
              <Heading textStyle="heading-sm" level={2} css={wizardHeadingStyles}>
                What are your financial expectations for renters?
              </Heading>
            )}

            <FinancialExpectationsIntroAndFields />
          </Box>

          <WizardTipCardContainer
            header="Increase the chance of finding a tenant on Zillow"
            icon={<IconHouseHeartFilled />}
            showDesktopViewBreakpoint={showDesktopViewBreakpoint}
          >
            <div data-testid="WizardTipContent">
              <Paragraph css={{ marginBottom: '400' }}>
                More landlords who set screening criteria reported finding their renter on Zillow.
              </Paragraph>
              <Paragraph textStyle="body-xs" color="text.subtle">
                Source: Zillow internal data, Q1 2024
              </Paragraph>
            </div>
          </WizardTipCardContainer>
        </Box>
      </div>
    </PageWizard>
  );
};

export default FinancialExpectations;
